module.exports = __webpack_public_path__ + "static/media/13.b316576c.webp";